import ConcealmentAnalytics from "../service/AnalyticsService";

window.addEventListener('DOMContentLoaded', () => {
  ConcealmentAnalytics.getPlausible()
});

